// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainSection_mainContainer__4ZiCn","filtersContainer":"mainSection_filtersContainer__Sdnww"};